import React from "react";
import Box from "react-raster";
import { theme } from "src/config/theme";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { AuthStore } from "src/stores";
import { inject, observer } from "mobx-react";
import { Language } from "src/types";
export interface ILanguagMenuProps {
  onClick?: () => void;
  isOpen?:    boolean;
  authStore?: AuthStore;
}

const MenuBox = styled(Box)`
  position:         absolute;
  display:          flex;
  flex-direction:   column;
  right:            0;
  left:             1.5rem;
  bottom:           5rem;
  width:            8rem;
  height:           fit-content;
  font-size:        ${theme.font.size.small};
  color:            ${theme.color.black};
  background-color: ${theme.color.white};
  box-shadow:       ${theme.boxShadow.small};
  border-radius:    0.3rem;
  cursor:           pointer;
  z-index:          100;
`;

const MenuItem = styled.li`
  display:         flex;
  flex-direction:  row;
  align-items:     center;
  justify-content: space-between;
  padding:         0.8rem 0.8rem;
  list-style-type: none;
  font-size:       ${theme.font.size.small};

  :hover {
    border-radius: 0.3rem 0.3rem 0rem 0rem;
    background:    ${theme.color.hover};
  }

  :first-child {
    border-radius: 0.3rem 0.3rem 0rem 0rem;
  }

  :nth-child(2n) {
    border-radius: 0rem 0rem 0.3rem 0.3rem;
  }
`;

export const LanguageMenu = inject("authStore")(observer((props: ILanguagMenuProps): JSX.Element => {
  const { onClick, isOpen, authStore } = props;
  const { t, i18n } = useTranslation();

  return (
    <MenuBox>

      <MenuItem
        onClick={() => {
          authStore.getCurUser.changeLanguage(Language.EN);
          onClick();
        }}
      >
        {t("english")}
      </MenuItem>
      <MenuItem
        onClick={() => {
          authStore.getCurUser.changeLanguage(Language.SV);
          onClick();
        }}
      >
        {t("swedish")}
      </MenuItem>
    </MenuBox>
  );
}));
